import {useTranslation} from "react-i18next";
import {useState} from "react";
import {ReactComponent as CalenderIcon} from "../../../asset/icons/calenderIconGray.svg";
import DatePickerModal from "../DatePicker";
import './style.scss'

const initialState = {
  fa: "",
  en: "",
  set: false,
}

function DBDateFilter({onEndDate, onRemoveEndDate, onStartDate, onRemoveStartDate, className = ''}) {
  const {t} = useTranslation()
  const [startDate, setStartDate] = useState(initialState);
  const [endDate, setEndDate] = useState(initialState);
  const [startDatePicker, setStartDatePicker] = useState(false);
  const [endDatePicker, setEndDatePicker] = useState(false);

  return (
    <div className={`DBDateFilter ${className}`}>
      <div className='DBDateFilter-box'>
        <CalenderIcon/>
      </div>
      <div className='DBDateFilter-date-box'>
        <div className='DBDateFilter-date-item'>
          <span>
            {t("UserPanel.Surveys&announcments.SurveyAnnouncments.FromDate.Label")}
          </span>
          <input
            type="text"
            defaultValue={startDate.fa}
            onClick={() => setStartDatePicker(true)}
            placeholder={t("UserPanel.dashboard.FeedbackHistoyShowcase.Date.Label")}
            className="date-in"
            readOnly
          />
          {startDate.fa ?
            <button onClick={() => {
              setStartDate(initialState)
              onRemoveStartDate?.()
            }}>
              حذف
            </button>
            : null}
        </div>
        <div className='DBDateFilter-date-item'>
          <span>
            {t("UserPanel.Surveys&announcments.SurveyAnnouncments.UntillDate.Label")}
          </span>
          <input
            type="text"
            defaultValue={endDate.fa}
            onClick={() => setEndDatePicker(true)}
            placeholder={t("UserPanel.dashboard.FeedbackHistoyShowcase.Date.Label")}
            className="date-in"
            readOnly
          />
          {endDate.fa ?
            <button onClick={() => {
              setEndDate(initialState)
              onRemoveEndDate?.()
            }}>
              حذف
            </button>
            : null}
        </div>
      </div>
      <DatePickerModal
        show={startDatePicker}
        close={setStartDatePicker}
        defaultValue={startDate.fa}
        onChange={(value) => {
          setStartDatePicker(false)
          setStartDate(value)
          onStartDate(value)
        }}
      />
      <DatePickerModal
        show={endDatePicker}
        close={setEndDatePicker}
        defaultValue={endDate.fa}
        onChange={(value) => {
          setEndDatePicker(false)
          setEndDate(value)
          onEndDate(value)
        }}
      />
    </div>
  );
}

export default DBDateFilter;
